import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Brand } from "../../models/brand.model";

@Injectable()
export class BrandProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getSelectedBrand(): Observable<Brand> {
    return this.http
      .get<Brand>(`${this.url}/brands/selected-brand`)
      .map(response => {
        return new Brand(response);
      })
      .catch(this.handleError)
  }

  getBrands(): Observable<Brand[]> {
    return this.http
      .get<Brand[]>(`${this.url}/brands`)
      .map(response => {
        return response.map((brand) => new Brand(brand));
      })
      .catch(this.handleError)
  }

  postSelectedBrand(brandId: Object): Observable<boolean> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http
      .post<boolean>(`${this.url}/brands/select-brand`, { 'brandId': brandId }, {
        headers: headersConfig
      }).catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/brand/brand.ts